export default __webpack_public_path__ + "static/media/Corpse-Waker's Band.4b0783da.jpg";